<template>
    <transition appear name="fade-transition">
        <span class="display__link">
            <app-link :to="linkValue" :target="target">
                <slot v-if="findSlot('display')" name="display" />
                <template v-else>{{ displayValue }}</template>
            </app-link>
        </span>
    </transition>
</template>

<script>
import Display from './Display';

export default {
    name: 'DisplayLink',
    extends: Display,
    props: {
        target: {
            type: String,
            default: '_blank'
        }
    },
    computed: {
        linkValue() {
            return this.value;
        }
    }
};
</script>

<style lang="scss" scoped>
.display__link {
    min-width: 10rem;
    text-align: left;
}
</style>
